import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/dailyView${`?date=${string}&datesToLoad=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/dailyView`;

export const URL = (/** format: MM-DD-YYYY */date: string, /** format: MM-DD-YYYY */datesToLoad: string[]): RouteDefinition =>
	`${baseRoute}/dailyView?date=${date}&datesToLoad=${JSON.stringify(datesToLoad)}`;
